import { defineStore } from 'pinia';

export enum EDashboardReportName {
  HOME = 'home-dashboard',
  MITRE = 'mitre-dashboard',
  SIEM = 'siem-dashboard',
  AZURE_SENTINEL = 'azure-sentinel-dashboard',
  EDR = 'edr-dashboard',
  EDR_CROWDSTRIKE = 'edr-crowdstrike-dashboard',
  CASES = 'cases-dashboard',
  CISO = 'ciso-dashboard',
  VULNERABILITY = 'vulnerability-report',
  PATCH_MANAGEMENT = 'patch-management-report',
  PROMPT_AI = 'prompt-ai-dashboard',
  FORTIANALYZER = 'fortianalyzer-dashboard',
}

interface DashboardVisitedState {
  [EDashboardReportName.MITRE]: boolean;
  [EDashboardReportName.SIEM]: boolean;
  [EDashboardReportName.AZURE_SENTINEL]: boolean;
  [EDashboardReportName.EDR]: boolean;
  [EDashboardReportName.EDR_CROWDSTRIKE]: boolean;
  [EDashboardReportName.CASES]: boolean;
  [EDashboardReportName.CISO]: boolean;
  [EDashboardReportName.VULNERABILITY]: boolean;
  [EDashboardReportName.PATCH_MANAGEMENT]: boolean;
  [EDashboardReportName.PROMPT_AI]: boolean;
  [EDashboardReportName.FORTIANALYZER]: boolean;
}

interface DasboardVisitedCount {
  [EDashboardReportName.MITRE]: number;
  [EDashboardReportName.SIEM]: number;
  [EDashboardReportName.AZURE_SENTINEL]: number;
  [EDashboardReportName.EDR]: number;
  [EDashboardReportName.EDR_CROWDSTRIKE]: number;
  [EDashboardReportName.CASES]: number;
  [EDashboardReportName.CISO]: number;
  [EDashboardReportName.VULNERABILITY]: number;
  [EDashboardReportName.PATCH_MANAGEMENT]: number;
  [EDashboardReportName.PROMPT_AI]: number;
  [EDashboardReportName.FORTIANALYZER]: number;
}

const DEFAULT_DASHBOARD_VISITED = {
  [EDashboardReportName.MITRE]: false,
  [EDashboardReportName.SIEM]: false,
  [EDashboardReportName.AZURE_SENTINEL]: false,
  [EDashboardReportName.EDR]: false,
  [EDashboardReportName.EDR_CROWDSTRIKE]: false,
  [EDashboardReportName.CASES]: false,
  [EDashboardReportName.CISO]: false,
  [EDashboardReportName.VULNERABILITY]: false,
  [EDashboardReportName.PATCH_MANAGEMENT]: false,
  [EDashboardReportName.PROMPT_AI]: false,
  [EDashboardReportName.FORTIANALYZER]: false,
};

const DEFAULT_DASHBOARD_COUNT = {
  [EDashboardReportName.MITRE]: 0,
  [EDashboardReportName.SIEM]: 0,
  [EDashboardReportName.AZURE_SENTINEL]: 0,
  [EDashboardReportName.EDR]: 0,
  [EDashboardReportName.EDR_CROWDSTRIKE]: 0,
  [EDashboardReportName.CASES]: 0,
  [EDashboardReportName.CISO]: 0,
  [EDashboardReportName.VULNERABILITY]: 0,
  [EDashboardReportName.PATCH_MANAGEMENT]: 0,
  [EDashboardReportName.PROMPT_AI]: 0,
  [EDashboardReportName.FORTIANALYZER]: 0,
};

export const useDashboardReportStore = defineStore('dashboard-report-store', {
  state: (): { dashboardVisited: DashboardVisitedState; dashboardVisitedCount: DasboardVisitedCount } => ({
    dashboardVisited: {
      ...DEFAULT_DASHBOARD_VISITED,
    },
    dashboardVisitedCount: {
      ...DEFAULT_DASHBOARD_COUNT,
    },
  }),
  actions: {
    setDashboardVisited(dashboardName: EDashboardReportName, value: boolean = true) {
      this.dashboardVisited[dashboardName] = value;
    },
    resetDefault() {
      this.dashboardVisited = { ...DEFAULT_DASHBOARD_VISITED };
      this.dashboardVisitedCount = { ...DEFAULT_DASHBOARD_COUNT };
    },
    increaseVisitedCount(dashboardName: EDashboardReportName, count: number = 1) {
      this.dashboardVisitedCount[dashboardName] += count;
    },
    resetFirstRenderCount(dashboardName) {
      this.dashboardVisitedCount[dashboardName] = 1;
    },
  },
});
